'use client';
import { jsx } from 'react/jsx-runtime';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Input } from './Input.js';

const InputGroupDivider = /*#__PURE__*/withTitan(({
  label,
  className
}) => {
  return jsx(Input, {
    "aria-hidden": true,
    isCentered: true,
    isDivider: true,
    isLabelHidden: true,
    className: className,
    label: "Input group divider",
    name: "divider",
    placeholder: label,
    tabIndex: -1,
    width: "30px"
  });
}, {
  name: 'InputGroupDivider',
  memo: true
});

export { InputGroupDivider };
//# sourceMappingURL=InputGroupDivider.js.map
